import { render } from "./TextToSpeechItem.vue?vue&type=template&id=04bde2f8&scoped=true&ts=true"
import script from "./TextToSpeechItem.vue?vue&type=script&lang=ts"
export * from "./TextToSpeechItem.vue?vue&type=script&lang=ts"

import "./TextToSpeechItem.vue?vue&type=style&index=0&id=04bde2f8&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bde2f8"]])

export default __exports__